import BaseListPresenter from "../../base/BaseListPresenter";
import { getCurrentUserUseCase } from "../../usecases/user";
import {
  format,
  startOfDay,
  addHours,
  addMinutes,
  addDays,
  parseISO,
} from "date-fns";

class ReportPresenter extends BaseListPresenter {
  constructor(view, findObjectUseCase, countObjectUseCase, exportCSVUseCase) {
    super(view, findObjectUseCase, countObjectUseCase, exportCSVUseCase);
    this.exportCSVUseCase = exportCSVUseCase;
  }
  init() {
    this.limit = 50000;
    this.where = {};
    this.search = {};
    this.filter = {};
    this.filterDate = {};
    this.filterType = {};
    this.filterStore = {};
    this.include = ["all"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  reset() {
    this.objects = [];
    this.view.state.aggregateData = {};
    this.count = 0;
    this.current = 1;
    this.view.setObjects([]);
    this.view.setSelected([]);
    this.view.setCount(0);
    this.view.setTotal(0);
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: {
        ...this.where,
        ...this.search,
        ...this.filter,
        ...this.filterDate,
        ...this.filterType,
      },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  // async findObjects() {
  //   try {
  //     const user = await getCurrentUserUseCase().execute();
  //     const storeQuery = {
  //       include: ["all"],
  //       where: { email: user.email },
  //     };
  //     this.store = await this.findObjectUseCase.execute("users", storeQuery);

  //     const store = this.store[0].storeAnalytic.sort((a, b) => {
  //       const nameA = a.name.toUpperCase();
  //       const nameB = b.name.toUpperCase();
  //       return nameA.localeCompare(nameB);
  //     });

  //     this.view.setStore(store);
  //   } catch (error) {
  //     console.error("Error fetching user or store data:", error);
  //     return;
  //   }

  //   const skip = (this.current - 1) * this.limit;
  //   const storeCodes = this.store?.flatMap((storeItem) =>
  //     storeItem.storeAnalytic?.map((analytic) => analytic?.name)
  //   );

  //   const whereClause = {
  //     ...this.filterDate,
  //     store_code:
  //       this.filterStore === "AllStore"
  //         ? { $in: storeCodes }
  //         : this.filterStore,
  //   };

  //   const query = {
  //     skip: skip,
  //     where: whereClause,
  //     include: ["all"],
  //     sort: this.sort,
  //     keys: [
  //       "store_code",
  //       "tran_date",
  //       "total",
  //       "total_taxfree",
  //       "total_tax",
  //       "discount_amount",
  //       "createdAt",
  //       "cust_name",
  //       "tran_type",
  //       "paymenttype",
  //       "cust_count",
  //       "total_pretax",
  //       "status",
  //     ],
  //   };

  //   try {
  //     this.showProgress();
  //     this.findObjectUseCase.abort();

  //     const { count } = await this.countObjectUseCase.execute(
  //       this.view.getCollectionName(),
  //       { where: query.where }
  //     );

  //     console.log("this.count", count);
  //     this.count = count;
  //     this.view.setCount(count);

  //     // Reset UI state
  //     this.objects = [];
  //     this.view.setObjects([]);
  //     this.view.setTotal(0);
  //     this.view.setNotFound(false); // reset before fetch

  //     let timeoutId = null;

  //     if (this.count === 0) {
  //       // Delay the "Data not found" m
  //       // essage
  //       timeoutId = setTimeout(() => {
  //         if (this.count === 0) {
  //           console.log("leng", this.objects?.length);
  //           console.log(
  //             "No data received after delay. Setting NotFound = true"
  //           );
  //           this.view.setNotFound(true);
  //           // this.view.setObjects([]);
  //           // this.view.setTotal(0);
  //         }
  //       }, 30000); // 15 seconds delay
  //     }

  //     // Setup batching
  //     let buffer = [];

  //     const flushBuffer = () => {
  //       if (buffer.length > 0) {
  //         this.view.setState((prevState) => ({
  //           objects: [...prevState.objects, ...buffer],
  //         }));
  //         this.objects = this.objects.concat(buffer);
  //         this.view.setTotal(this.objects.length);
  //         this.view.setObjects(this.objects);
  //         buffer = [];
  //       }
  //     };

  //     const onData = (objects) => {
  //       if (objects.length > 0 && timeoutId) {
  //         clearTimeout(timeoutId);
  //         timeoutId = null;
  //         this.view.setNotFound(false);
  //       }
  //       buffer.push(...objects);
  //     };

  //     const flushInterval = setInterval(flushBuffer, 2000);

  //     await this.findObjectUseCase.execute(
  //       this.view.getCollectionName(),
  //       query,
  //       {
  //         timeout: 100000,
  //         onData,
  //       }
  //     );

  //     clearInterval(flushInterval);
  //     flushBuffer();
  //   } catch (error) {
  //     console.error("Error fetching objects:", error);
  //     this.view.showError(error);
  //   } finally {
  //     this.hideProgress();
  //     this.progress = false;
  //   }
  // }

  async findObjects() {
    // 1) Load user + store (kailangan bago gumawa ng whereClause)
    try {
      const user = await getCurrentUserUseCase().execute();
      const storeQuery = { include: ["all"], where: { email: user.email } };
      this.store = await this.findObjectUseCase.execute("users", storeQuery);

      const store = (this.store?.[0]?.storeAnalytic ?? []).sort((a, b) =>
        a.name.toUpperCase().localeCompare(b.name.toUpperCase())
      );
      this.view.setStore(store);
    } catch (error) {
      console.error("Error fetching user or store data:", error);
      return;
    }

    // 2) Build base filters (AllStore -> $in ng lahat ng analytic names)
    const storeCodes =
      this.store?.[0]?.storeAnalytic?.map((a) => a?.name).filter(Boolean) ?? [];

    const whereClause = {
      ...this.filterDate,
      store_code:
        this.filterStore === "AllStore"
          ? { $in: storeCodes }
          : this.filterStore,
    };

    // fixed: true batching size
    const pageSize = this.limit || 50000;

    // 3) Count muna gamit ang full filter
    let totalCount = 0;
    try {
      this.showProgress();
      this.findObjectUseCase.abort(); // cancel any in-flight

      const { count } = await this.countObjectUseCase.execute(
        this.view.getCollectionName(),
        { where: whereClause }
      );

      totalCount = count ?? 0;
      this.count = totalCount;
      this.view.setCount(totalCount);

      // Reset UI state
      this.objects = [];
      this.view.setObjects([]);
      this.view.setTotal(0);
      this.view.setNotFound(false);

      // Not-found delay (optional)
      let timeoutId = null;
      if (totalCount === 0) {
        timeoutId = setTimeout(() => {
          if (this.objects.length === 0) {
            console.log("No data after delay. Setting NotFound = true");
            this.view.setNotFound(true);
          }
        }, 30000);
        // Walang data — wala nang ipe-fetch na pages
        if (timeoutId) clearTimeout(timeoutId);
        return;
      }

      // 4) Batch pagination loop
      let fetched = 0;
      let page = 0;

      // Shared buffer + periodic flush (para smooth ang UI)
      let buffer = [];
      const flushBuffer = () => {
        if (buffer.length === 0) return;
        this.objects = this.objects.concat(buffer);
        this.view.setObjects(this.objects);
        this.view.setTotal(this.objects.length);
        buffer = [];
      };
      const flushInterval = setInterval(flushBuffer, 1000);

      try {
        while (fetched < totalCount) {
          const skip = page * pageSize;

          const query = {
            skip,
            limit: pageSize, // <<— important: 20 per batch
            where: whereClause,
            include: ["all"],
            sort: this.sort,
            keys: [
              "store_code",
              "tran_date",
              "total",
              "total_taxfree",
              "total_tax",
              "discount_amount",
              "createdAt",
              "cust_name",
              "tran_type",
              "paymenttype",
              "cust_count",
              "total_pretax",
              "status",
            ],
          };

          // Per-page local buffer via onData
          let pageRowCount = 0;
          const onData = (objects) => {
            if (objects?.length) {
              buffer.push(...objects);
              pageRowCount += objects.length;
            }
          };

          // Execute one page (may stream sa loob, pero hanggang `limit` lang)
          await this.findObjectUseCase.execute(
            this.view.getCollectionName(),
            query,
            { timeout: 120000, onData }
          );

          // Push whatever came in this page
          flushBuffer();

          // Walang dumating sa page na ito → tapos na
          if (pageRowCount === 0) break;

          fetched += pageRowCount;
          page += 1;

          // Yield para hindi ma-block UI thread
          await Promise.resolve();
        }
      } finally {
        clearInterval(flushInterval);
        flushBuffer();
      }

      // Safeguard
      if (this.objects.length === 0) {
        this.view.setNotFound(true);
      }
    } catch (error) {
      console.error("Error fetching objects:", error);
      this.view.showError(error);
    } finally {
      this.hideProgress();
      this.progress = false;
    }
  }

  getTranType(tranType) {
    const tranTypeMapping = {
      U: "Delivery",
      D: "Dine In",
      T: "Take Out",
      G: "GrabFood",
      F: "FoodPanda",
      P: "Pick Up",
      B: "Del Time",
      K: "Drive-thru",
      H: "Tablevibe",
    };
    return tranTypeMapping[tranType];
  }

  async aggregateData() {
    const objects = this.objects;
    const aggregatedData = {};

    objects.forEach((obj) => {
      const storeCode = obj.store_code;

      if (!aggregatedData[storeCode]) {
        aggregatedData[storeCode] = {};
        aggregatedData[storeCode].totalNetSales = 0;
        aggregatedData[storeCode].totalGrossSales = 0;
        aggregatedData[storeCode].totalPretax = 0;
        aggregatedData[storeCode].totalTax = 0;
        aggregatedData[storeCode].totalTaxFree = 0;
        aggregatedData[storeCode].totalDiscount = 0;
        aggregatedData[storeCode].totalVoidAmount = 0;
        aggregatedData[storeCode].totalVoidCount = 0;
      }

      if (obj.status === "C") {
        const tranType = this.getTranType(obj.tran_type);

        if (!aggregatedData[storeCode][tranType]) {
          aggregatedData[storeCode][tranType] = { tc: 0, netSale: 0 };
        }

        const grossSale = parseFloat(obj.total) || 0;
        const netSale = grossSale;
        const totalNetSales = grossSale - (parseFloat(obj.total_tax) || 0);
        const totalGrossSales = grossSale;
        const totalPretax = parseFloat(obj.total_pretax) || 0;
        const totalTax = parseFloat(obj.total_tax) || 0;
        const totalTaxFree = parseFloat(obj.total_taxfree) || 0;
        const totalDiscount = parseFloat(obj.discount_amount) || 0;

        aggregatedData[storeCode][tranType].tc += 1;
        aggregatedData[storeCode][tranType].netSale += netSale;
        aggregatedData[storeCode].totalNetSales += totalNetSales;
        aggregatedData[storeCode].totalGrossSales += totalGrossSales;
        aggregatedData[storeCode].totalPretax += totalPretax;
        aggregatedData[storeCode].totalTax += totalTax;
        aggregatedData[storeCode].totalTaxFree += totalTaxFree;
        aggregatedData[storeCode].totalDiscount += totalDiscount;
      }

      if (obj.status === "V") {
        // ✅ Handle voids
        const voidAmount = parseFloat(obj.total) || 0;
        aggregatedData[storeCode].totalVoidAmount += voidAmount;
        aggregatedData[storeCode].totalVoidCount += 1;
      }
    });

    this.view.setState({ aggregatedData });
  }

  async getObjects() {
    this.reset();
    await this.findObjects();
    await this.aggregateData();
  }

  onChangeDate(where) {
    const { tran_date } = where;

    if (tran_date && tran_date.$gte && tran_date.$lte) {
      const startDate = addHours(startOfDay(parseISO(tran_date.$gte)), 5);
      const endDate = addMinutes(
        addHours(addDays(startOfDay(parseISO(tran_date.$lte)), 0), 4),
        59
      );

      const formattedStartDate = format(startDate, "yyyy-MM-dd HH:mm:ss.SSS");
      const formattedEndDate = format(endDate, "yyyy-MM-dd HH:mm:ss.SSS");

      this.filterDate = {
        tran_date: {
          $gte: formattedStartDate,
          $lte: formattedEndDate,
        },
      };
    }
    this.getObjects();
  }
  onChangeStore(where) {
    this.filterStore = where;
    this.getObjects();
  }

  onChangeType(where) {
    this.filterType = { tran_type: where };
    this.getObjects();
  }
}

export default ReportPresenter;
